import React, { useRef } from "react";

import useAnchoredPopover, { elementAnchor } from "./useAnchoredPopover";

export default function ClozeOptionsPanel({ anchorTestId, options, wrongPicks, onChoose, onClose }) {
  const panelRef = useRef(null);
  const style = useAnchoredPopover({ anchor: elementAnchor(anchorTestId), panelRef, onClose });

  return (
    <div aria-label="Answer choices" className="cloze-options-panel" data-testid="cloze-story-options" ref={panelRef} role="dialog" style={style}>
      {options.map((option) => {
        const isWrong = wrongPicks.includes(option);
        return (
          <button
            className={`cloze-option${isWrong ? " wrong" : ""}`}
            data-testid={`cloze-story-option-${option}`}
            disabled={isWrong}
            key={option}
            type="button"
            onClick={() => onChoose(option)}
          >
            {isWrong && <span className="fa fa-times cloze-option-wrong-icon" />}
            {option}
          </button>
        );
      })}
    </div>
  );
}
